import React, { useState } from "react";
import { useRouter } from "next/router";
import { Box } from "@chakra-ui/react";
import { customEvent, getCdnImageSrc, Image } from "goi_common";
import { BaseButton } from "goi_common/src/design-system/components/BaseButton";
import { BaseStack } from "goi_common/src/design-system";
import TutorialCarousel from "goi_common/src/design-system/composites/TutorialCarousel";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";

const TUTORIAL_IMAGES = [
  "direct/promotion/3-d-3/2609-3d3-1.png",
  "direct/promotion/3-d-3/2609-3d3-2.png",
  "direct/promotion/3-d-3/2609-3d3-3.png",
  "direct/promotion/3-d-3/2609-3d3-4-v2.png",
  "direct/promotion/3-d-3/2609-3d3-5.png",
  "direct/promotion/3-d-3/2609-3d3-6.png",
];

export default function Promotion253D3Container() {
  const router = useRouter();
  const [currentIndex, setCurrentIndex] = useState(0);

  const { paths } = useFunnelRouteDeclare({
    uniqueKey: landingFunnelKey.GROUP["promotion_25_3d3_mt_zero"],
  });

  const isFirstSlide = currentIndex === 0;

  const handlePrev = () => {
    if (currentIndex > 0) {
      customEvent({
        newGtm: {
          path: "home",
          trigger_and_target: `btn_prev_${currentIndex + 1}`,
        },
      });
      setCurrentIndex(currentIndex - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNext = () => {
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: `btn_next_${currentIndex + 1}`,
      },
    });

    if (currentIndex < TUTORIAL_IMAGES.length - 1) {
      setCurrentIndex(currentIndex + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    // HomeV23D3PromotionContainer의 CTA 클릭 이벤트와 완전히 동일하게 GTM 전송
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "CTA",
      },
    });
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: "hero_CTA-uv_registration",
      },
    });
    router.push(paths.verification);
  };

  return (
    <TutorialCarousel
      currentIndex={currentIndex}
      CarouselItems={TUTORIAL_IMAGES.map((src, index) => (
        <Box key={index} width="100%">
          <Image
            src={getCdnImageSrc(src)}
            width="100%"
            height="auto"
            alt={`Step ${index + 1}`}
          />
        </Box>
      ))}
      FixedButtons={
        <BaseStack direction="horizontal" width="100%" spacing="8px">
          {!isFirstSlide && (
            <Box flex={1}>
              <BaseButton
                type="assistive_1"
                size="large"
                outlined={true}
                onClick={handlePrev}
              >
                <Box className="body_16_m">이전</Box>
              </BaseButton>
            </Box>
          )}
          <Box flex={1}>
            <BaseButton type="primary" size="large" onClick={handleNext}>
              <Box className="body_16_m">다음</Box>
            </BaseButton>
          </Box>
        </BaseStack>
      }
    />
  );
}
